export class SearchState {
  isEnabled: boolean;
  searchText: string;

  constructor(isEnabled: boolean, searchText: string) {
    this.isEnabled = isEnabled;
    this.searchText = searchText;
  }
}
